jQuery(document).ready(function($){
	$('body').on('click', '.rvadv_plan_part_card', function (e) {
		e.preventDefault();
		var gallery = $('.rvadv_plan_part_card').map(function () {
			return {
				src: $(this).data('image'),
				caption: $(this).data('title'),
				type: 'image'
			};
		}).get();

		var startIndex = $('.rvadv_plan_part_card').index(this);

		Fancybox.show(gallery, {
			startIndex: startIndex
		});
	});
});

